import React from "react";
import RecipeTitle from "./../../images/recipe.png";
import { Fade } from "react-reveal";

function RecipeHeader() {
  return (
    <header id="recipe-header" className="text-center">
      <Fade duration={2500}>
        <img
          src={RecipeTitle}
          id="recipes-heading"
          alt="Recipes Title"
          className="ocean-label"
        />
      </Fade>
    </header>
  );
}

export default RecipeHeader;
